import Lottie from 'lottie-react';
import travelling from './animations/travelling-person.json';

function ContactUsPage() {
  return (
    <div className="ContactUsPage">
      <h1>Contact Us</h1>
      <p style={{ textAlign: 'center' }}>
        For general inquiries, please contact <b>livingoutofabackpack.service@gmail.com</b>
      </p>

      <h1>Copyright</h1>
      <p>
        If you believe that any content violates your copyright please contact us via the same email <b>livingoutofabackpack.service@gmail.com</b>.
      </p>

      <p>
        We take copyright infringement claims seriously. Any well-founded notice will be treated as a potential violation of our Terms and Policies. We are committed to responding to allegations that
        comply with the Digital Millennium Copyright Act (DMCA) or other applicable intellectual property laws.
      </p>

      <p>Our goal is to resolve such matters amicably and efficiently. We sincerely hope that any concerns can be addressed collaboratively without the need for legal escalation.</p>

      <div className="ContactLottieWrap">
        <Lottie animationData={travelling} loop={true} style={{ height: '150px' }} />
      </div>
    </div>
  );
}

export default ContactUsPage;
